CustomTC.define('jquery/event/support',[
	"../var/support"
], function( support ) {

support.focusinBubbles = "onfocusin" in window;

return support;

});

